import React from 'react'
import {useTranslation} from 'react-i18next'

import downloadIcon from 'assets/download.svg'

import Button from 'features/common/components/Button'
import Spinner from 'features/common/components/Spinner'
import useQR from '../../../../common/hooks/useQR'

const QRCode = () => {
    const {t} = useTranslation()
    const {data, onDownload, isLoading} = useQR()

    if (isLoading) {
        return <Spinner yellow className="h-20 w-20 self-center" />
    }

    if (!data) {
        return <div>-</div>
    }

    return (
        <>
            <img
                className="h-auto w-60 rounded-3xl border-8 border-dashed border-yellow-40"
                src={data}
                alt="qr"
            />
            <div>
                <Button
                    onClick={onDownload}
                    className="flex gap-4 rounded-full py-5 px-6"
                >
                    {t('QR_DOWNLOAD')}
                    <img src={downloadIcon} alt="download" />
                </Button>
            </div>
        </>
    )
}

export default QRCode
